import { NavLink } from 'react-router-dom';
import { KeyRound, Settings } from 'lucide-react';
import { useHasPermission } from 'utils/hooks';

const navItems = [
    { label: 'General', to: '/settings', exact: true, icon: Settings },
    {
        label: 'API Keys',
        to: '/settings/api',
        permission: 'api.secret_key.manage',
        icon: KeyRound,
    },
];

function SettingsSidebar() {
    const { hasPermission: canManageSecretKeys } = useHasPermission(
        'api.secret_key.manage',
    );

    return (
        <nav className="flex w-56 shrink-0 flex-col border-r border-border bg-background">
            <div className="border-b border-border px-4 pb-4 pt-4">
                <h2 className="text-lg font-semibold text-foreground">
                    Settings
                </h2>
            </div>
            <div className="flex flex-col gap-1 p-2">
                {navItems.map((item) => {
                    if (
                        item.permission === 'api.secret_key.manage' &&
                        !canManageSecretKeys
                    ) {
                        return null;
                    }
                    const Icon = item.icon;
                    return (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            exact={item.exact}
                            className="flex h-8 items-center gap-2 rounded-md px-2 text-sm font-normal leading-none text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"
                            activeClassName="bg-sidebar-accent font-medium text-sidebar-accent-foreground"
                        >
                            <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />
                            {item.label}
                        </NavLink>
                    );
                })}
            </div>
        </nav>
    );
}

export default SettingsSidebar;
